// extracted by css-extract-rspack-plugin
export default {"nodeTitle":"nodeTitle-3PFaS"};